import { Currency } from '@99designs/design-services-common';
import { MpvId } from './productConfig';
import { TierId, TierLocale } from './tierConfig';

export type Price = {
    amount: number;
    currency: Currency;
};

type FlexibleTierPriceConfig = {
    [tier in TierId]: Partial<Record<TierLocale, Price>>;
};

export type PricesConfig = {
    [key in MpvId]: FlexibleTierPriceConfig;
};

const standardTierPricing: FlexibleTierPriceConfig = {
    simpleDesign: {
        'en-US': { amount: 10, currency: 'USD' as Currency },
    },
    exclusiveDesign: {
        'en-US': { amount: 39, currency: 'USD' as Currency },
    },
};

export const PRICES: PricesConfig = {
    standardbusinesscards: {
        simpleDesign: {
            'en-AU': { amount: 19, currency: 'AUD' as Currency },
            'en-US': { amount: 10, currency: 'USD' as Currency },
        },
        exclusiveDesign: {
            'en-AU': { amount: 49, currency: 'AUD' as Currency },
            'en-US': { amount: 39, currency: 'USD' as Currency },
        },
    },
    postcards: standardTierPricing,
    bifoldbrochures: standardTierPricing,
    vinylbanners: standardTierPricing,
    retractablebanners: standardTierPricing,
    bellacanvasunisexshortsleevejerseytshirtdtg2go: standardTierPricing,
    posters: standardTierPricing,
    flyers: standardTierPricing,
    flyersandleaflets: {
        simpleDesign: {
            'en-AU': { amount: 29, currency: 'AUD' as Currency },
        },
        exclusiveDesign: {
            'en-AU': { amount: 59, currency: 'AUD' as Currency },
        },
    },
};
